import { Contract } from "../../../../modules/contracts/api/contract.schema";
import { Customer } from "../../../../modules/customers/api/customer.schema";
import Spinner from "../../../_ui/Spinner/Spinner";

import Typography from "../../../_ui/Typography/Typography";

import styles from "./SearchDropDown.module.css";

interface Props {
    isLoading?: boolean;
    items: Array<Customer> | Array<Contract>;
    noneFoundMessage: string;
    onSelect: (id: number, name: string) => void;
}

export default function SearchDropDown({ isLoading, items, onSelect, noneFoundMessage }: Props) {
    return (
        <ul className={styles.dropdown}>
            {isLoading ? (
                <li className={styles.padding}>
                    <Spinner size="medium" color="text-content-accent" className="mx-auto" />
                </li>
            ) : (
                <>
                    {items.length ? items.map((item) => (
                        <Typography key={item.id} as="li" variant="meta">
                            <button onClick={() => onSelect(item.id!, item.name)} title={`Add ${item.name}`}>
                                {item.name}
                            </button>
                        </Typography>
                    )) : (
                        <Typography as="li" variant="meta" className={styles.padding}>
                            {noneFoundMessage}
                        </Typography>
                    )}
                </>
            )}
        </ul>
    );
}
